var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "201px",
    height: "209px",
    viewBox: "0 0 201 209",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-mark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.107909,20.4622939 C129.274629,22.8918276 128.693298,25.4284765 128.393014,28.0447563 C120.695266,25.8915605 112.574164,24.7395833 104.181737,24.7395833 C58.5043382,24.7395833 20.8643876,58.8644823 15.7731979,102.807752 C14.6334705,102.591043 13.4567383,102.477591 12.2532846,102.477591 C10.7477782,102.477591 9.28409036,102.655141 7.88235294,102.990278 C12.9258852,54.665246 54.1159495,16.98125 104.181737,16.98125 C113.161798,16.98125 121.856311,18.1936153 130.107909,20.4622939 Z M188.224716,65.2911249 C196.352833,79.3436396 201,95.6289643 201,112.990625 C201,128.457807 197.311684,143.070733 190.759643,156.011701 C188.841756,154.21668 186.652815,152.7034 184.260122,151.538602 C189.972101,139.891809 193.176302,126.812281 193.176302,112.990625 C193.176302,96.6931089 188.721356,81.4274081 180.953179,68.3256987 C183.498251,67.5383928 185.93153,66.5179588 188.224716,65.2911249 Z M11.0411248,139.291094 C11.4418524,139.316682 11.8460385,139.329674 12.2532846,139.329674 C14.576905,139.329674 16.8009083,138.906726 18.8512773,138.134229 C29.7689534,174.624542 63.8407753,201.241667 104.181737,201.241667 C120.962327,201.241667 136.658167,196.636099 150.053954,188.630113 C151.433314,190.882342 153.145613,192.911856 155.123117,194.651487 C140.325496,203.748175 122.872098,209 104.181737,209 C59.9069908,209 22.5734327,179.529534 11.0411248,139.291094 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 104.441176,
    cy: 113.64375,
    rx: 53.205882,
    ry: 52.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 12.480392,
    cy: 120.828125,
    rx: 12.480392,
    ry: 12.409375
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 170.784314,
    cy: 173.73125,
    rx: 19.705882,
    ry: 19.59375
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 168.156863,
    cy: 32.65625,
    rx: 32.843137,
    ry: 32.65625
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.31f4d585462774c62019c240f2f6fcc6.svg";
export { ForwardRef as ReactComponent };